import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Arrow Round Right Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      _createElementVNode("path", { d: "m9.25.5 2.5 2.5-2.5 2.5" }),
      _createElementVNode("path", { d: "M12.25 8.25A5.25 5.25 0 1 1 7 3h4.75" })
    ], -1)
  ]))]))
}
export default { render: render }